import { dataOff, dataOn, dataOnce, dataSet } from "../../main/data/data";
export function handleRefreshes(pageId, cb) {
    const refreshRef = "refresh";
    let waitForIt;
    dataOnce(refreshRef).then(() => {
        const data = {
            init: pageId,
            pages: 0,
        };
        dataSet(refreshRef, data)
            .then(() => {
            if (cb && typeof cb.request === "function") {
                cb.request();
            }
        })
            .catch((e) => {
            if (cb && typeof cb.error === "function") {
                cb.error(e);
            }
        });
    });
    dataOn(refreshRef, (data) => {
        clearTimeout(waitForIt);
        waitForIt = setTimeout(() => {
            dataOff(refreshRef);
            dataSet("refresh/init", false);
            const count = Object.keys(data.pages).length;
            if (cb && typeof cb.success === "function") {
                cb.success(count);
            }
        }, 1000);
    });
}
